export const environment = {
  production: false,
  apiBaseUrl: 'https://mais-lernapp-backend.wjs-projects.de/api',
};
